import { render, staticRenderFns } from "./load-rating-calculator.vue?vue&type=template&id=22aaf554&scoped=true"
import script from "./load-rating-calculator.vue?vue&type=script&lang=js"
export * from "./load-rating-calculator.vue?vue&type=script&lang=js"
import style0 from "./load-rating-calculator.vue?vue&type=style&index=0&id=22aaf554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aaf554",
  null
  
)

export default component.exports